import { DataSource, Image, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCommodityQuickInfo extends Layout {
    labelHazmat: Image;
    sourceCommodity: DataSource;
    textboxDescr: Textbox;
    textboxHazmatNumber: Textbox;
    textboxId: Textbox;
}
